import React, { forwardRef } from 'react';

import { ComponentIconProps } from '../types';

const BreadcrumbsPileIcon = forwardRef<SVGSVGElement, ComponentIconProps>(
  ({ className, size = 24 }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      data-testid="WeaveBreadcrumbsPileIcon"
      style={{ flex: 'none' }}
    >
      <path d="M18.5,10A2.5,2.5,0,1,0,21,12.5,2.5,2.5,0,0,0,18.5,10Zm0,4A1.5,1.5,0,1,1,20,12.5,1.5,1.5,0,0,1,18.5,14Z" />
      <path d="M11.5,10A2.5,2.5,0,1,0,14,12.5,2.5,2.5,0,0,0,11.5,10Zm0,4A1.5,1.5,0,1,1,13,12.5,1.5,1.5,0,0,1,11.5,14Z" />
      <path d="M4.5,10A2.5,2.5,0,1,0,7,12.5,2.5,2.5,0,0,0,4.5,10Zm0,4A1.5,1.5,0,1,1,6,12.5,1.5,1.5,0,0,1,4.5,14Z" />
    </svg>
  ),
);

BreadcrumbsPileIcon.displayName = 'BreadcrumbsPileIcon';

export default BreadcrumbsPileIcon;
